import { Modals } from "./types";

export const modalsZIndex: Record<Modals, number> = {
  [Modals.ONBOARDING]: 100,
  [Modals.SEARCH]: 101,
  [Modals.BRAND]: 102,
  [Modals.LINK]: 103,
  [Modals.OPTIN]: 104,
};
